import { AIDatasetAssistant } from "@/components/AIDatasetAssistant";
import { ToastType } from "@/enums";
import { displayToast } from "@/utils/toast";

interface AIImportProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onVariablesFetched?: (variables: Record<string, string>) => void;
  promptTemplate?: string;
}

export const AIImport = ({
  isOpen,
  onOpenChange,
  onVariablesFetched,
  promptTemplate = "",
}: AIImportProps) => {
  const handleVariablesGenerated = (variables: Record<string, string>) => {
    onVariablesFetched?.(variables);
    displayToast("Variables generated successfully!", ToastType.success);
    onOpenChange(false);
  };

  return (
    <AIDatasetAssistant
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      onVariablesGenerated={handleVariablesGenerated}
      promptTemplate={promptTemplate}
    />
  );
};
